module.exports = __webpack_public_path__ + "img/华为城堡.08ac76de.png";